<template>
  <div class="mb-3 field-container" :class="{ error: !!field.error }">
    <label
      :for="field.id"
      class="form-label"
      :class="{ 'text-danger': !!field.error }"
      >{{ field.name + (field.required ? '*' : ' ') }}
      <Tooltip
        v-show="!!field.tooltipInfo"
        :id="field.id"
        :info="field.tooltipInfo"
      />
    </label>

    <p style="display:none">
      {{ field.value }}
    </p>
    <p class="regions-link">
      <a v-show="field.link" :href="field.link" target="_blank">Regions</a>
    </p>
    <b-form-select
      class="form-control custom-select no-border"
      :options="
        field.options.find(el => el.value === 'pd-extreme')
          ? field.options.splice(1, 1)
          : field.options
      "
      v-model="selected"
      @change="getSelectedOption($event)"
    >
      Please select an option
    </b-form-select>
  </div>
</template>
<script>
import Tooltip from '../global/Tooltip.vue';
import store from '../../store';
export default {
  name: 'SelectField',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
  data: () => {
    return {
      selected: null,
      store,
    };
  },

  mounted() {
    this.selected = this.field.value;
    if (this.field.apiConfig) {
      this.fetchOptionsFromApi(this.field.apiConfig);

      this.$watch(
        'field.apiConfig.url',
        (oldVal, newVal) => {
          if (newVal !== oldVal) this.fetchOptionsFromApi(this.field.apiConfig);
        },
        {
          deep: true,
        }
      );
    }
    this.$emit('input', this.field.value);
  },
  methods: {
    fetchOptionsFromApi(config) {
      const optionsUrl = `${config.url}`;

      fetch(optionsUrl, {
        method: 'GET',
      })
        .then(res => res.json())
        .then(data => {
          setTimeout(() => {
            this.$emit('update', {
              fieldId: this.field.id,
              data,
              keys: config.keys,
            });
          }, 0);
        });
      // .catch(err =>
      //   console.error(`Error fetching values from ${this.field.apiUrl}`, err)
      // );
    },
    getSelectedOption($event) {
      //saving the label value  for options.
      this.field.labelvalue = this.field.options.filter(
        item => item.value === $event
      )[0]['text'];
      this.$emit('input', $event);
    },
  },
  updated() {
    this.selected = this.field.value;
  },
};
</script>

<style lang="scss" scoped>
.no-border {
  border: 0;
  box-shadow: none;
}
.field-container {
  border: 0.5px solid #b1b1b1;
  border-radius: 3px;
  padding: 2px 12px;
}
.form-label {
  font-size: 13px;
  line-height: 19px;
}
.regions-link {
  font-size: 13px;
  padding: 0;
  text-decoration: underline;
}
.form-control {
  border: none;
  padding: 3px 0 8px 0;
  font-size: 18px;
  line-height: 22px;
}
.custom-select {
  margin-left: -2px;
  background: none;
  appearance: auto;
  color: #000;
}
.error {
  border-color: $danger;
}
@media (max-width: 768px) {
  .form-control {
    font-size: 14px;
  }
}
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .form-label {
      margin-left: 0px;
    }
  }
}
</style>
